/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerFindCountsQueryResponse,
  TelegramProductsUserControllerFindCounts401,
} from '../types/TelegramProductsUserControllerFindCounts.ts';

function getTelegramProductsUserFindCountsUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/products/counts` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/counts}
 */
export async function telegramProductsUserFindCounts(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsUserControllerFindCountsQueryResponse,
    ResponseErrorConfig<TelegramProductsUserControllerFindCounts401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsUserFindCountsUrl().url.toString(), ...requestConfig });
  return res.data;
}
